import Image from 'next/image';
import type { ReactNode } from 'react';
import React from 'react';

import { cn } from '@/libs/utils';

export default function SectionHead({
  title,
  description,
  className,
  image,
}: {
  title: ReactNode;
  description?: ReactNode;
  image?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'my-5 flex flex-col items-center gap-1 text-center',
        className,
      )}
    >
      {image && (
        <Image
          width={72}
          height={72}
          src={image}
          alt="Section icon"
          className="mx-auto block"
        />
      )}
      <h1 className="text-2xl font-bold">{title}</h1>
      {description && (
        <p className="max-w-[400px] text-center text-sm font-light sm:w-11/12 md:w-10/12">
          {description}
        </p>
      )}
    </div>
  );
}
